import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, List, Typography } from '@iho-design-system/Loader';

const RightBar = ({ props, scrollQuestionProps }) => {

    /*
        - defaultData
    */
    const [platformSubjects, setPlatformSubjects] = React.useState([]);

    React.useEffect(() => {
        if (props.platformSubjects.status === 200) {
            setPlatformSubjects(props.platformSubjects.data[0].Childs);
        }
    }, [props]);

    return (

        <React.Fragment>
            <Typography
                component='h3'
                className={`my-xl mt-0`}>
                راهنما
            </Typography>
            <Box
                ms={{
                    position: 'sticky',
                    top: '8px'
                }}>
                <Box
                    className={`my-xl mt-0 border-solid border-medium overflow-hidden rounded-lg`}
                    ms={{
                        backgroundColor: 'var(--white)',
                        '@media(max-width:576px)': {
                            backgroundColor: '#f1f2f3',
                            border: 'none',
                        }
                    }}>
                    <List
                        className={`d-block`}
                        ms={{
                            '@media(max-width:576px)': {
                                display: 'none !important'
                            }
                        }}>
                        {platformSubjects.map((obj, index) => {
                            return (
                                <List.Item
                                    key={index}
                                    onClick={() => scrollQuestionProps(obj.Title)}
                                    className={`p-md pointer`}
                                    ms={{
                                        borderBottom: '1px solid var(--gray-medium)',
                                        '&:hover': {
                                            backgroundColor: 'var(--gray-light)'
                                        }
                                    }}>
                                    {obj.Title}
                                </List.Item>
                            );
                        })}
                    </List>
                    <Box
                        className={`d-none`}
                        ms={{
                            '@media(max-width:576px)': {
                                display: 'd-flex !important',
                                flexWrap: 'wrap',
                                justifyContent: 'center'
                            }
                        }}>
                        {platformSubjects.map((obj, index) => {
                            return (
                                <Box
                                    key={index}
                                    onClick={() => scrollQuestionProps(obj.Title)}
                                    className={`m-xs p-xs rounded-sm`}
                                    ms={{
                                        backgroundColor: 'var(--gray-medium)'
                                    }}>
                                    {obj.Title}
                                </Box>
                            );
                        })}
                    </Box>
                </Box>
            </Box>

        </React.Fragment>

    );

}

export default RightBar;